import { useEffect, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { Generico } from "../../components/Generico";
import { useForm } from "react-hook-form";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { AreaNegocio } from "../../models/matriz/AreaNegocio";
import { Toolbar } from "primereact/toolbar";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";

export const AreaFactor = ({ permss, generic, toast, factor, catalogo, empresa }) => {

    const omodel = new AreaNegocio();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues, shouldTrim: true });
    const monitoreoSrv = new MonitoreoService();
    const [registers, setRegisters] = useState(null);
    const [area, setArea] = useState(null);
    const [dialogArea, setDialogArea] = useState(false);

    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inNumber } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        _lazyParams.factor = factor?.id;
        if (empresa && empresa?.id) {
            _lazyParams.empresa = empresa.id;
        }
        monitoreoSrv.listado('matriz-factor/area/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);

        });
    }

    const openNew = () => {
        setArea(null);
        reset(defaultValues);
        setDialogArea(true);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar factor', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el ítem?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                monitoreoSrv.eliminar(area?.id, 'matriz-factor/area/eliminar').then(res => {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Factor eliminado', life: 3000 });
                    loadLazyData();
                }).catch(error => {
                    generic.funcDeleteError(error, toast);
                });
            }
        });
    }

    const onSubmit = (data) => {
        if (empresa && empresa?.id) {
            data.empresa = empresa.id;
        }
        if (getValues('id') == null) {
            data.factor = factor?.id;
            monitoreoSrv.nuevo(data, 'matriz-factor/area/nuevo').then(res => {
                generic.funcSuccess(res, toast);
                setDialogArea(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            monitoreoSrv.editar(data, 'matriz-factor/area/editar').then(res => {
                generic.funcSuccess(res, toast);
                setDialogArea(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editar = () => {
        monitoreoSrv.consultar(area?.id, 'matriz-factor/area/consulta').then(res => {
            const _area = res.data;
            const lista = { tipo_negocio: catalogo?.negocio, plantilla: catalogo?.plantilla, valor: catalogo?.valor };

            Object.keys(lista).forEach(function (key) {
                if (_area[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _area[key]) {
                            _area[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_area, omodel.model));
            setDialogArea(true);
        });
    };

    return (
        <>
            <br />
            <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, '', permss)}></Toolbar>
            {table({ action01: accionesTbl, reg: setArea, items: itemsMenu() })}

            <Dialog visible={dialogArea} header={getValues('id') == null ? "Nuevo registro" : "Editar información"} modal className="p-fluid modal-ssize" onHide={() => {
                setDialogArea(false);
            }}
                style={{ maxWidth: '400px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <br />
                    <div className="formgrid grid">
                        {inDrop('tipo_negocio', catalogo?.negocio, { lab: omodel.optionLabel }, 12)}
                        {inDrop('plantilla', catalogo?.plantilla, { lab: omodel.optionLabel }, 12)}
                        {inNumber('orden', 0, false, {}, 12)}
                        {inDrop('valor', catalogo?.valor, { lab: omodel.optionLabel }, 12)}
                        {inText('formula', {}, 12)}
                    </div>
                    {generic.buttonsForms(setDialogArea)}
                </form>
            </Dialog>
        </>
    )
}
